enum Colors {
  main = "#9747FF",
  textGray = "#252525",
  lightTextGray = "#757575",
  backgroundWhite = "#EAEAEA",
  backgroundGray = "#D1D1D1",
  disabledMain = "#cba3ff",
  disabledTextGray = "#5B5B5B",
}

export default Colors;
